export default "__VITE_ASSET__55648967__"